import styled from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';

export const StyledBoxWrapper = styled.div`
  padding: 1rem 2rem;
`;

export const StyledText = styled('span')({
  fontSize: 16,
  color: '#000'
});

export const StyledLoginWrapper = styled('div')({
  display: 'flex',
  margin: '30px 5rem 0',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 18,
  padding: '30px 0 0',
  borderTop: `1px solid ${lightColorPalette.lbBlue_20}`
});

export const StyledContentHeader = styled.h1`
  color: #000;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.9px;
`;

export const StyledSubHeader = styled('h2')({
  fontSize: 18,
  color: '#000',
  fontWeight: 'normal',
  textAlign: 'center'
});
